import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex gap-4 align-items-center mb-4" }
const _hoisted_2 = ["id", "onChange", "disabled"]
const _hoisted_3 = { class: "dialog-footer" }

import { ref, nextTick } from "vue";
import DocsServices from "../../services/DocsServices";
import { ElMessage } from "element-plus";
import { useStore } from "@/store";
import { Delete } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadDocuments',
  emits: ["submitted"],
  setup(__props, { expose: __expose, emit: emits }) {

const store = useStore();
const user = store.state.AuthModule.user;
const title = ref("");
const dialogRef = ref(false);
const isLoading = ref(false);
const id = ref(0);
const fileList = ref<any>({});
const uploadedLinks = ref<any>([]);
const operatorInfo = ref<any>({
  name: user.nativeName,
  email: user.email,
  updatedAt: new Date().toISOString(),
});
const docsLanguages = ref<any>({});

const uploadRefs = ref<any>({});

for (const [language, file] of Object.entries(fileList.value)) {
  uploadRefs.value[language] = null;
}

const handleFileUpload = (event: Event, key: any) => {
  const target = event.target as HTMLInputElement;
  if (target.files) {
    const files = Array.from(target.files);
    files.forEach((file) => {
      const fileType = file.type;
      const validTypes = [
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      ];

      if (!validTypes.includes(fileType)) {
        alert("Please upload a valid Word document (.doc or .docx)");
        removeFile(key);
        return;
      }

      const markedFile = Object.assign(file, {
        language: key,
      });
      fileList.value[key] = markedFile;
    });
  }
  console.log(fileList.value);
};

const show = (_data: any, _languages) => {
  id.value = _data.id;
  title.value = _data.title;
  dialogRef.value = true;
  docsLanguages.value = _languages;
};

const hide = () => {
  fileList.value = {};
  docsLanguages.value = {};
  uploadedLinks.value = [];
  dialogRef.value = false;
};

const removeFile = (key: any) => {
  delete fileList.value[key];
  nextTick(() => {
    const inputRef = uploadRefs.value[key];
    if (inputRef) {
      inputRef.value = "";
    }
  });
};

const submit = async () => {
  isLoading.value = true;

  try {
    const formData = new FormData();
    for (const [language, file] of Object.entries(fileList.value)) {
      formData.append("files[]", file, file.name);
      formData.append("languages[]", language);
    }
    formData.append("operator_info", JSON.stringify(operatorInfo.value));
    const res = await DocsServices.uploadDocuments(id.value, formData);
    uploadedLinks.value = res;
    ElMessage.success("Documents uploaded successfully");
    emits("submitted");
  } catch (error) {
    ElMessage.error("Upload file failed, file too large or invalid format");
  }
  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('fields.uploadDocumentsFor') + ' : ' + title.value,
    width: "900",
    "align-center": "",
    "before-close": hide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: isLoading.value,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.upload")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docsLanguages.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_tag, {
              for: 'file-input-' + index,
              class: "w-75px",
              type: "warning"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(index), 1)
              ]),
              _: 2
            }, 1032, ["for"]),
            _createElementVNode("input", {
              id: 'file-input-' + index,
              type: "file",
              ref_for: true,
              ref: (el) => (uploadRefs.value[index] = el),
              onChange: ($event: any) => (handleFileUpload($event, index)),
              disabled: isLoading.value,
              class: "form-control"
            }, null, 40, _hoisted_2),
            (fileList.value[index])
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: ($event: any) => (removeFile(index)),
                  disabled: isLoading.value,
                  type: "danger",
                  icon: _unref(Delete),
                  circle: ""
                }, null, 8, ["onClick", "disabled", "icon"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLinks.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_el_link, {
            href: item,
            target: "_blank",
            type: "success",
            class: "ms-3",
            underline: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["href"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})